import React from "react";
import { Row, Col } from "react-bootstrap";
import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import { format } from "date-fns";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function ReceiptAccount() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const { RecReceiptAcdata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  // const getMetrics = (data) => {
  //   return [
  //     {
  //       title: "BALANCE",
  //       value: formatIndianRupee(data.BalanceAmt ?? 0),
  //       percent: getPercent(data.BalanceAmt, data.TotalSale),
  //     },
  //     {
  //       title: "OVERDUE",
  //       value: formatIndianRupee(data.OvrBalanceAmt ?? 0),
  //       percent: getPercent(data.OvrBalanceAmt, data.TotalSale),
  //     },
  //     {
  //       title: "TURNOVER DAYS",
  //       value: data.TurnOverDays ?? "0",
  //       percent: "", // Turnover days me % nahi lagega
  //     },
  //     {
  //       title: "TOTAL SALES",
  //       value: formatIndianRupee(data.TotalSale ?? 0),
  //       percent: "",
  //     },
  //     {
  //       title: "TOTAL RECEIPT",
  //       value: formatIndianRupee(data.TotalReceipt ?? 0),
  //       percent: "",
  //     },
  //   ];
  // };

  const getRows = RecReceiptAcdata?.Detail?.map((label, index) => ({
    srNumber: index + 1,
    ProductionGroupMstName: label.ProductionGroupMstName,
    AcName: label.AcName,
    BalanceAmt: label.BalanceAmt,
    OvrBalanceAmt: label.OvrBalanceAmt,
    OverDuePer: label.OverDuePer,
    PaymentTerms: label.PaymentTerms,
    OverDueDays: label.OverDueDays,
    TurnOverDays: label.TurnOverDays,
    TotalSale: label.TotalSale,
    TotalReceipt: label.TotalReceipt,
    DaysLastReceipt: label.DaysLastReceipt,
    DaysAfterLastDate: label.DaysAfterLastDate,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "ProductionGroupMst Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Receivable Balance",
      key: "BalanceAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Receivable OvrBalance",
      key: "OvrBalanceAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Receivable OverDuePer",
      key: "OverDuePer",
      align: "right",
      format: "true",
    },
    {
      label: "Payment Terms",
      key: "PaymentTerms",
      align: "right",
      format: "true",
    },
    {
      label: "OverDue Days",
      key: "OverDueDays",
      align: "right",
      format: "true",
    },
    {
      label: "TurnOver Days",
      key: "TurnOverDays",
      align: "right",
      format: "true",
    },
    { label: "Total Sales", key: "TotalSale", align: "right", format: "true" },
    {
      label: "Total Receipt",
      key: "TotalReceipt",
      align: "right",
      format: "true",
    },
    {
      label: "Days sinc Last sales",
      key: "DaysAfterLastDate",
      align: "right",
      format: "true",
    },
    {
      label: "Days Last Receipt",
      key: "DaysLastReceipt",
      align: "right",
      format: "true",
    },
  ];

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount || 0));
  };

  const calculateTotal = (key) => {
    if (!RecReceiptAcdata?.Detail || !Array.isArray(RecReceiptAcdata.Detail)) return 0;
    return RecReceiptAcdata.Detail.reduce((sum, item) => sum + (Number(item[key]) || 0), 0);
  };

  const receiptData = [
    { title: "BALANCE", value: calculateTotal("BalanceAmt") },
    {
      title: "OVERDUE",
      value: calculateTotal("OvrBalanceAmt"),
    },
    {
      title: "OVERDUE %",
      value: calculateTotal("OverDuePer"),
    },
    {
      title: "TURNOVER DAYS",
      value: calculateTotal("TurnOverDays"),
    },
    {
      title: "TOTAL SALES",
      value: calculateTotal("TotalSale"),
    },
    {
      title: "TOTAL RECEIPT",
      value: calculateTotal("TotalReceipt"),
    },
  ];

  if (RecReceiptAcdata === "no" || RecReceiptAcdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
      }`,
    borderLeft: `6px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
      }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };

  return (
    <div>
      <Row className="g-3">
        {receiptData?.map((item, index) => (
          <Col
            key={index}
            xl={2}
            lg={4}
            md={4}
            sm={6}
            xs={12}
            className="quarter-box"
          >
            <div style={cardStyle}>
              <h6 style={subtitleStyle}>
                {item.title === "OVERDUE %" || item.title === "TURNOVER DAYS"
                  ? Number(item.value || 0).toFixed(2)
                  : formatAmount(item.value)}
              </h6>
              <p style={titleStyle}>{item.title}</p>

              {item.percent && <small>{item.percent}%</small>}
            </div>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              RECEIPT ACCOUNT
            </h2>
          </div>
          <FASParentChild
            data={getRows}
            columns={getColumns}
            parentKey="ProductionGroupMstName"
          // childKey="AcName"
          />
        </div>
      </div>
    </div>
  );
}
